import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import { addTown, changeTown, fetchTowns, removeTown } from './services';

export const townsSlice = createSlice({
  name: 'towns',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchTowns.pending, (state, action) => {
      state.error = undefined;
      state.currentRequestId = action.meta.requestId;
    });
    builder.addCase(fetchTowns.rejected, (state, action) => {
      if (state.currentRequestId !== action.meta.requestId) return;

      state.error = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchTowns.fulfilled, (state, action) => {
      if (state.currentRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.towns = action.payload;
      state.currentRequestId = undefined;
    });

    builder.addCase(removeTown.fulfilled, (state, action) => {
      state.towns.delete(action.meta.arg);
    });

    builder.addCase(addTown.fulfilled, (state, action) => {
      state.towns.set(action.payload.townId, action.payload);
    });

    builder.addCase(changeTown.fulfilled, (state, action) => {
      state.towns.set(action.payload.townId, action.payload);
    });
  },
});

export const { actions: townsActions, reducer: townsReducer } = townsSlice;
